import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { media } from '@yoweb/ui/styles/utils';
import { getColor, getDuration, getSpace, getZIndex } from '@yoweb/ui/styles/utils/theme';
import { CloseIcon } from '@yoweb/ui/components/Icon/CloseIcon';
import { theme } from '@yoweb/ui/styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RenderState;

(function (RenderState) {
  RenderState[RenderState["CLOSED"] = 0] = "CLOSED";
  RenderState[RenderState["NAVIGATING"] = 1] = "NAVIGATING";
  RenderState[RenderState["OPEN"] = 2] = "OPEN";
})(RenderState || (RenderState = {}));

export var ColorMode;

(function (ColorMode) {
  ColorMode[ColorMode["DARK"] = 0] = "DARK";
  ColorMode[ColorMode["LIGHT"] = 1] = "LIGHT";
})(ColorMode || (ColorMode = {}));

var IDS = {
  container: 'mobile-nav-container',
  content: 'mobile-nav-content',
  openButton: 'mobile-nav-open-button',
  closeButton: 'mobile-nav-close-button',
  overlay: 'mobile-nav-overlay'
};

var NavContainer = function NavContainer(_ref) {
  var bodyOpenClassName = _ref.bodyOpenClassName,
      children = _ref.children,
      _ref$colorMode = _ref.colorMode,
      colorMode = _ref$colorMode === void 0 ? ColorMode.DARK : _ref$colorMode,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? RenderState.CLOSED : _ref$state,
      _ref$isNavigating = _ref.isNavigating,
      isNavigating = _ref$isNavigating === void 0 ? false : _ref$isNavigating;
  var mobileNavRef = useRef(null);
  useEffect(function () {
    if (bodyOpenClassName) {
      if (state === RenderState.CLOSED) {
        document.body.classList.remove(bodyOpenClassName);
      } else {
        document.body.classList.add(bodyOpenClassName);
      }
    }
  }, [bodyOpenClassName, state]);
  return /*#__PURE__*/_jsxs(MobileNavigation, {
    "data-testid": IDS.container,
    colorMode: colorMode,
    ref: mobileNavRef,
    state: state,
    isAbove: hasCloseButton || isNavigating,
    children: [/*#__PURE__*/_jsxs(MobileNavigationContent, {
      colorMode: colorMode,
      state: state,
      "data-testid": IDS.content,
      children: [hasCloseButton && /*#__PURE__*/_jsx(CloseButton, {
        colorMode: colorMode,
        onClick: onClose,
        "data-testid": IDS.closeButton,
        children: /*#__PURE__*/_jsx(CloseIcon, {
          size: "1rem"
        })
      }), children]
    }), /*#__PURE__*/_jsx(NavigationOverlay, {
      "data-testid": IDS.overlay,
      variants: {
        initial: {
          y: '100%'
        },
        navigating: {
          y: '0%'
        }
      },
      initial: isNavigating ? 'navigating' : 'initial',
      animate: isNavigating ? 'navigating' : 'initial',
      transition: {
        duration: theme.transitionDuration.visual / 1000
      }
    })]
  });
};

var mobileNavIsOpenCss = css(["pointer-events:auto;transition:transform ", "ms,opacity ", "ms,visibility 0 ", "ms;visibility:visible;&::before{transform:translateY(0);}"], getDuration('visual'), getDuration('visual'), getDuration('visual'));
var MobileNavigation = styled.nav.withConfig({
  componentId: "sc-ft3iq0-0"
})(["inset:0;padding:", ";pointer-events:none;position:fixed;transition:transform ", "ms,opacity ", "ms,visibility 0;transition-duration:", "ms;visibility:hidden;", " &::before{inset:0;content:'';display:block;position:absolute;transform:translateY(100%);transition:transform ", "ms;z-index:", ";}", " ", " ", ""], getSpace('normal3'), getDuration('visual'), getDuration('visual'), getDuration('visual'), function (_ref2) {
  var isAbove = _ref2.isAbove;
  return isAbove ? css(["z-index:", ";"], getZIndex('above')) : null;
}, getDuration('visual'), getZIndex('behind'), function (_ref3) {
  var colorMode = _ref3.colorMode;
  var bgColorBefore = colorMode === ColorMode.DARK ? 'base1000' : 'base000';
  return css(["&::before{background-color:", ";}"], getColor(bgColorBefore));
}, function (_ref4) {
  var state = _ref4.state;

  switch (state) {
    case RenderState.CLOSED:
      return null;

    case RenderState.OPEN:
      return mobileNavIsOpenCss;
  }
}, media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var NavigationOverlay = styled(motion.div).withConfig({
  componentId: "sc-ft3iq0-1"
})(["background-color:", ";inset:0;position:absolute;"], getColor('base000'));
var MobileNavigationContent = styled.div.withConfig({
  componentId: "sc-ft3iq0-2"
})(["height:100%;opacity:0;position:relative;transform:translateY(50%);transition:transform,opacity;transition-duration:", "ms;", " ", ""], getDuration('interaction'), function (_ref5) {
  var colorMode = _ref5.colorMode;

  if (colorMode === ColorMode.DARK) {
    return css(["color:", ";"], getColor('base200'));
  }
}, function (_ref6) {
  var state = _ref6.state;

  switch (state) {
    case RenderState.CLOSED:
      return null;

    case RenderState.OPEN:
      return css(["opacity:1;transform:translateY(0);transition-delay:", "ms;transition-duration:", "ms;"], getDuration('shorter'), getDuration('visual'));
  }
});
var CloseButton = styled.button.withConfig({
  componentId: "sc-ft3iq0-3"
})(["background:transparent;border:none;display:block;margin:0 0 auto ", ";padding:0;", ""], getSpace('normal1'), function (_ref7) {
  var colorMode = _ref7.colorMode;

  if (colorMode === ColorMode.DARK) {
    return css(["color:", ";"], getColor('base000'));
  }
});
export default NavContainer;